// ProductStockEdit.js

import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { server } from "../../server";
import FlexBetween from "components/FlexBetween";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { toast } from "react-toastify";
import { ArrowLeftSharp } from "@mui/icons-material";
import { useGetUserQuery } from "state/api";
import { useSelector } from "react-redux";

const ProductStockEdit = () => {
  const { id } = useParams();
  const [productInfo, setProductInfo] = useState(null);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const userId = useSelector((state) => state.global.userId);
  const { data } = useGetUserQuery(userId);

  const [formData, setFormData] = useState({
    name: "",
    desc: "",
    category: "",
    price_achat: 0,
    stock: 0,
    userId: userId,
    userName: data?.name || "",
  });

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axios.get(`${server}/product/a-product/${id}`);
        setProductInfo(response.data.products);

        setFormData((prevFormData) => ({
          ...prevFormData,
          name: response.data.products.name,
          desc: response.data.products.desc,
          price_achat: response.data.products.price_achat,
        }));
      } catch (error) {
        console.error("Error fetching product:", error);
        toast.error("Erreur lors de la récupération du produit.");
      }
    };

    fetch();
  }, [id]);

  useEffect(() => {
    if (data) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        userName: data.name,
      }));
    }
  }, [data]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${server}/product/update-product-stock/${id}`,
        formData,
        { withCredentials: true }
      );
      toast.success("Produit mis à jour avec succès");
      setTimeout(() => {
        window.location.replace("/achats");
      }, 1000);
    } catch (error) {
      console.error("Error updating product stock:", error);
      toast.error(
        error.response?.data?.message ||
          "Une erreur s'est produite lors de la mise à jour du produit."
      );
    }
  };

  return (
    <div>
      {productInfo ? (
        <div>
          <Box m="20px">
            <FlexBetween>
              <Link to={"/achats"}>
                <Button
                  color="secondary"
                  variant="contained"
                  style={{ marginBottom: "6px" }}
                >
                  <ArrowLeftSharp />
                  Retour
                </Button>
              </Link>
              <Header title="Modifier un produit" />
            </FlexBetween>

            <Formik>
              {() => (
                <form onSubmit={handleUpdate}>
                  <Box
                    display="grid"
                    marginTop="20px"
                    gap="30px"
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <TextField
                      fullWidth
                      variant="filled"
                      type="string"
                      label="Nom du produit"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      sx={{ gridColumn: "span 2" }}
                      disabled
                    />
                    <TextField
                      fullWidth
                      variant="filled"
                      type="string"
                      label="Description"
                      value={formData.desc}
                      onChange={(e) =>
                        setFormData({ ...formData, desc: e.target.value })
                      }
                      sx={{ gridColumn: "span 2" }}
                      disabled
                    />
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Prix d'achat"
                      value={formData.price_achat}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          price_achat: e.target.value,
                        })
                      }
                      sx={{ gridColumn: "span 4" }}
                      disabled
                    />
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Stock à ajouter"
                      value={formData.stock}
                      onChange={(e) =>
                        setFormData({ ...formData, stock: e.target.value })
                      }
                      sx={{ gridColumn: "span 4" }}
                    />
                  </Box>
                  <Box display="flex" justifyContent="end" mt="20px">
                    <Button color="secondary" variant="contained" type="submit">
                      Mettre à jour le stock
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
          </Box>
        </div>
      ) : (
        <div>Aucun produit trouvé</div>
      )}
    </div>
  );
};

export default ProductStockEdit;
